<script type="text/jsx">
export default {
    name: 'UiAvatar',
    functional: true,
    render(h, { props, data }) {
        return (
            <div role="avatar"
                class={[props.disabled ? 'avatar-disabled' : (props.dark ? 'avatar-dark' : 'avatar'), 'flex items-center justify-center rounded-full ph-no-capture', data.class, data.staticClass]}
                style={{ outline: `3px solid ${props.outlineColour}` }}
            >
                {(props.image) ?
                // Image version
                    <img class='flex items-center justify-center w-full h-full m-auto' rel={props.name || 'unknown'} src={props.image} />
                    :
                // Initials only
                    <div class="initials w-12 h-12 rounded-full flex justify-center items-center" role="person" rel={props.name || 'unknown'}>
                        {
                            (props.name)
                                ? props.name.split(' ').map(l => l[0]).join('').toUpperCase()
                                : '?'
                        }
                    </div>
                }
            </div>
        );
    },
};
</script>

<style lang="scss" scoped>
    $avatar-size-sm: 30px;
    $avatar-size-md: 72px;
    $avatar-size-lg: 120px;

    $avatar-text-sm: 12px;
    $avatar-text-md: 24px;
    $avatar-text-lg: 38px;

    .avatar {
        @apply text-white bg-mouse font-semibold;
        overflow: hidden;
        flex-shrink: 0;
    }

    .avatar-dark {
        @apply text-charcoal bg-mouse font-semibold;
        overflow: hidden;
        flex-shrink: 0;
    }

    .avatar-disabled {
        @apply text-elephant bg-light-gray font-semibold;
        overflow: hidden;
        flex-shrink: 0;
    }

    .sm {
        font-size: $avatar-text-sm;
        width: $avatar-size-sm;
        height: $avatar-size-sm;
    }

    .md {
        width: $avatar-size-md;
        height: $avatar-size-md;
        font-size: $avatar-text-md;
    }

    .lg {
        width: $avatar-size-lg;
        height: $avatar-size-lg;
        font-size: $avatar-text-lg;
    }
</style>
